import React from 'react'
import {connect} from 'react-redux'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import DoubleButton from "components/popup/components/DoubleButton";
import VS from "constants/ValidationShema";
import PropTypes from 'prop-types'
import RadioGroup from "components/RadioGroup";
import AnnualReportsService from "services/AnnualReportsService";
import useSnackbar from "hooks/useSnackbar";
import annulaReportClasses from "../../constants/annulaReportClasses";


export const getMoveAnnualReportEntryConfig = (reportId, tableEntryId, currentType) => ({reportId, tableEntryId, currentType})

function MoveAnnualReportEntry(
    {
        onClose,
        items,
        inputLabel,
        config,
        reportStep,
        formSubmit
    }) {
    const classes = annulaReportClasses();
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();
    const {enqueueSuccessSnackbar} = useSnackbar();

    const submitFrom = (values) => {
        onClose();
        AnnualReportsService.moveAnnualReportTableEntry(config.reportId, config.tableEntryId, reportStep, config.currentType, values.type).then((result) => {
            if(result) {
                const section =  items.find(x => x.value === result.type);
                enqueueSuccessSnackbar(Tr("moved_demand_number_to_section", {number: result.number, section: (section ? section.label : "")}))
            }
        })

    }

    return (
        <Dialog
            title={inputLabel}
            open={true}
            maxWidth={'sm'}
            dialogActions={
                <DoubleButton
                    justify='flex-end'
                    labelFirst={Tr('cancel')}
                    labelSecond={Tr('confirm')}
                    onClickFirst={onClose}
                    onClickSecond={handleSubmit}
                    disabledSecond={items.length === 0}
                />}
        >

            <Form
                initialValues={{
                    type: null,
                }}
                validationSchema={Yup.object().shape({
                    type: VS.anyRequired()
                })}
                onSubmit={submitFrom}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>
                        {
                            items.length > 0 &&
                            <RadioGroup
                                items={items}
                                formikProps={formikProps}
                                // label={inputLabel}
                                id="type"
                                className={classes.moveEntryRadio}
                            />
                        }
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

MoveAnnualReportEntry.propTypes = {
    onClose: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    })).isRequired,
    inputLabel: PropTypes.string,
    config: PropTypes.shape({
        reportId: PropTypes.string.isRequired,
        tableEntryId: PropTypes.number.isRequired,
        currentType: PropTypes.string.isRequired
    }).isRequired,
    reportStep: PropTypes.string.isRequired,
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(MoveAnnualReportEntry);